import React from 'react';
import { useParams } from 'react-router-dom';

import { Layout } from '@.layout';

import { StoreClusterDashboard } from '../components';

export const StoreClusterDashboardAdminPage = () => {
    const { id } = useParams();

    const spStoreClusterId = Number(id);

    if (Number.isNaN(spStoreClusterId)) {
        throw new Error('incorrect store cluster id');
    }

    return (
        <Layout nobg>
            <StoreClusterDashboard spStoreClusterId={spStoreClusterId} />
        </Layout>
    );
};
